<template>
  <b-container fluid>
    <p>&nbsp;</p>
    <b-row>
      <b-col>
        <b-btn variant="primary" @click="onOpen">
          <fa-icon icon="plus"></fa-icon>
          新增資料集
        </b-btn>
        <b-btn
          @click="toggleViewMode"
          variant="info">
          <fa-icon icon="globe-americas" v-if="table.onlyMe"></fa-icon>
          <fa-icon icon="user" v-if="!table.onlyMe"></fa-icon>
          {{ table.onlyMe ? '顯示全部資料集' : '只顯示我的資料集' }}
        </b-btn>
        <div class="d-md-none mt-3"></div>
        <span class="text-secondary" v-if="status.refreshIcon">
          更新資料中 
          <fa-icon icon="spinner" spin></fa-icon>
        </span>
      </b-col>
      <b-col cols="12" md="3" align-self="end">
        <div class="d-md-none mt-3"></div>
        <b-form-group>
          <b-input-group>
            <b-input v-model="table.filter" placeholder="搜尋..." />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-table
        show-empty
        responsive
        stacked="md"
        :hover="true"
        :empty-text="constant.strings.emptyText"
        :empty-filtered-text="constant.strings.emptyFilteredText"
        :items="tableItem"
        :fields="table.fields"
        :current-page="table.currentPage"
        :per-page="table.perPage"
        :filter="table.filter"
        @filtered="onFiltered">
        <template slot="shareStatus" slot-scope="data">
          <fa-icon :icon="shareStatus(data).icon" :class="shareStatus(data).class"></fa-icon>
          <span :class="shareStatus(data).class">
            {{ shareStatus(data).text }}
          </span>
          &nbsp;
          <a
            :href="getCurrentHash"
            v-show="data.item.owner === id"
            @click="shareDataset(data)">設定</a>
        </template>
        <template slot="actions" slot-scope="data">
          <b-button
            size="sm"
            variant="primary"
            :disabled="data.item.owner !== id"
            @click.prevent.stop="onEdit(data.item.name)">
            <fa-icon icon="plus-circle"></fa-icon>
            加入照片
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            :disabled="data.item.owner !== id"
            @click.prevent.stop="onDelete(data.item.name)">
            <fa-icon icon="trash"></fa-icon>
            刪除資料集
          </b-button>
        </template>
      </b-table>
    </b-row>
    <b-row align-h="center">
      <b-col cols="6" md="3" align-self="center">
        <b-pagination
          :total-rows="table.totalRows"
          :per-page="table.perPage"
          v-model="table.currentPage" />
      </b-col>
    </b-row>

    <b-modal
      size="lg"
      scrollable
      :title="modalTitle"
      :busy="status.modal.busy"
      :no-close-on-backdrop="status.modal.busy"
      :no-close-on-esc="status.modal.busy"
      v-model="status.modal.show"
      @shown="autoFocus"
      @hidden="modalHidden">
      <b-form @submit.prevent.stop="onSubmit">
        <b-form-group label="資料集名稱">
          <b-input
            v-model="modal.name"
            placeholder="資料集名稱"
            ref="autofocus"
            :disabled="status.modal.onEdit"
            :state="$v.modal.name.specialChar"
            required>
          </b-input>
          <b-form-invalid-feedback>
            名稱不得包含特殊字元
          </b-form-invalid-feedback>
        </b-form-group>
        <b-tabs v-model="modal.mode" @input=modelTabSwitch>
          <b-tab active>
            <template slot="title">
              <fa-icon icon="file-archive"></fa-icon>
              上傳壓縮檔
            </template>
            <br>
            <b-form-group label="照片集">
              <b-file
                v-model="modal.zip.file"
                placeholder="選擇壓縮檔 (*.zip)"
                ref="zipFileInput"
                accept=".zip">
              </b-file>
            </b-form-group>
            <b-form-group label="影像標籤">
              <b-file
                v-model="modal.zip.tagFile"
                placeholder="選擇標籤檔 (*.csv)"
                ref="tagFileInput"
                accept=".csv">
              </b-file>
              <b-form-text>非必要</b-form-text>
            </b-form-group>
          </b-tab>
          <b-tab>
            <template slot="title">
              <fa-icon icon="images"></fa-icon>
              上傳影像檔
            </template>
            <br>
            <b-form-group
              label="照片集"
              :state="imageOverLimit ? false : null"
            >
              <b-file
                multiple
                v-model="modal.image.files"
                :state="imageOverLimit ? false : null"
                ref="imageFileInput"
                aria-describedby="inputImagesHelp"
                accept="image/*">
              </b-file>
              <div slot="invalid-feedback">
                <fa-icon icon="exclamation-triangle"></fa-icon>
                超出 {{ modal.image.files.length - constant.maxImageLimit }} 張影像，請減少影像數量再試一次
              </div>
              <b-form-text id="inputImagesHelp">
                單次最多可上傳 {{ constant.maxImageLimit }} 張影像
              </b-form-text>
            </b-form-group>
            <b-form-group label="影像標籤">
              <tags-input
                v-model.trim="modal.image.tags"
                wrapper-class="form-control"
                placeholder="加入標籤"
                add-tags-on-comma>
              </tags-input>
              <b-form-text>
                非必要。多個標籤請用 <kbd>,</kbd> 或 <kbd>↵</kbd> 分隔
              </b-form-text>
            </b-form-group>
          </b-tab>
          <b-tab>
            <template slot="title">
              <fa-icon icon="video"></fa-icon>
              上傳 Webcam 影像
            </template>
            <br>
            <b-row>
              <b-col
                class="text-center"
                style="margin-top: auto; margin-bottom: auto;">
                <video
                  autoplay
                  playsinline
                  muted
                  width="224"
                  height="224"
                  :style="{ transform: 'rotate(' + status.modal.webcam.rotate + 'deg)'}"
                  poster="../assets/poster-starting.png"
                  ref="video"></video>
                <b-row align-h="between" class="mt-2" style="width: 224px; margin: 0 auto;">
                  <div class="px-0">
                    <b-btn
                      variant="outline-info"
                      v-if="this.status.modal.webcam.statusCode >= 1"
                      @click="rotatePreview('webcam', -90)">
                      <fa-icon icon="undo"></fa-icon>
                      旋轉
                    </b-btn>
                  </div>
                  <div class="px-0">
                    <b-btn
                      variant="outline-info"
                      v-if="this.status.modal.webcam.statusCode >= 1"
                      @click="rotatePreview('webcam', 90)">
                      旋轉
                      <fa-icon icon="undo" transform="flip-h"></fa-icon>
                    </b-btn>
                  </div>
                </b-row>
              </b-col>
              <b-col>
                <span class="text-secondary">狀態</span>
                <h3 class="thin-title">{{ webcamStatusText }}</h3>
                <br>
                <b-button
                  :variant="captureButtonStatus.variant"
                  :disabled="this.status.modal.webcam.statusCode < 1"
                  @click="onCapture.call(this, 'webcam')">
                  <fa-icon :icon="captureButtonStatus.icon"></fa-icon>
                  {{ captureButtonStatus.text }}
                </b-button>
                <b-button
                  variant="danger"
                  :disabled="this.status.modal.webcam.statusCode < 1"
                  @click="clearFormData.call(this, 'webcam')">
                  <fa-icon icon="trash"></fa-icon>
                  清除影像
                </b-button>
                <div class="mt-2">
                  <b-form-checkbox
                    v-model="status.modal.webcam.autoMode"
                    :disabled="this.status.modal.webcam.statusCode < 1">
                    連續擷取模式
                  </b-form-checkbox>
                </div>
                <p>&nbsp;</p>
                <b-form-group label="影像標籤">
                  <tags-input
                    v-model.trim="modal.webcam.tags"
                    wrapper-class="form-control"
                    placeholder="加入標籤"
                    add-tags-on-comma
                  ></tags-input>
                  <b-form-text>
                    非必要。多個標籤請用 <kbd>,</kbd> 或 <kbd>↵</kbd> 分隔
                  </b-form-text>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template slot="title">
              <fa-icon icon="link"></fa-icon>
              由連結上傳
            </template>
            <br>
            <b-row>
              <b-col
                class="text-center"
                style="margin-top: auto; margin-bottom: auto;">
                <img
                  crossOrigin="Anonymous"
                  :src="status.modal.url.src"
                  :style="{
                    transform: 'rotate(' + status.modal.url.rotate + 'deg)',
                    width: 'auto',
                    height: 'auto',
                    'max-width': '224px',
                    'max-height': '224px'
                  }"
                  ref="url-upload-preview">
                <b-row align-h="between" class="mt-2" style="width: 224px; margin: 0 auto;">
                  <div class="px-0">
                    <b-btn
                      variant="outline-info"
                      v-if="status.modal.url.load"
                      @click="rotatePreview('url', -90)">
                      <fa-icon icon="undo"></fa-icon>
                      旋轉
                    </b-btn>
                  </div>
                  <div class="px-0">
                    <b-btn
                      variant="outline-info"
                      v-if="status.modal.url.load"
                      @click="rotatePreview('url', 90)">
                      旋轉
                      <fa-icon icon="undo" transform="flip-h"></fa-icon>
                    </b-btn>
                  </div>
                </b-row>
              </b-col>
              <b-col>
                <span class="text-secondary">狀態</span>
                <h3 class="thin-title">{{ urlUploadStatusText }}</h3>
                <b-alert variant="danger" :show="status.modal.url.hasError">
                  載入圖片時發生錯誤，請確定連結是否正確
                </b-alert>
                <b-form-group label="輸入影像來源連結" class="mt-3">
                  <b-input-group>
                    <b-input v-model.trim="status.modal.url.link"></b-input>
                    <b-button slot="append" variant="outline-primary" @click="loadURLPreview">載入</b-button>
                  </b-input-group>
                  <b-form-text>輸入以 http:// 或 https:// 開頭的連結</b-form-text>
                </b-form-group>
                <b-btn
                  :variant="captureButtonStatus.variant"
                  :disabled="!status.modal.url.load"
                  @click="onCapture.call(this, 'url')">
                  <fa-icon :icon="captureButtonStatus.icon"></fa-icon>
                    {{ captureButtonStatus.text }}
                </b-btn>
                <b-btn
                  variant="danger"
                  :disabled="!status.modal.url.load"
                  @click="clearFormData.call(this, 'url')">
                  <fa-icon icon="trash"></fa-icon>
                  清除影像
                </b-btn>
                <div class="mt-2">
                  <b-form-checkbox
                    v-model="status.modal.url.autoMode"
                    :disabled="!status.modal.url.load">
                    連續擷取模式
                  </b-form-checkbox>
                </div>
                <b-form-group label="影像標籤" class="mt-3">
                  <tags-input
                    v-model.trim="modal.url.tags"
                    wrapper-class="form-control"
                    placeholder="加入標籤"
                    add-tags-on-comma>
                  </tags-input>
                  <b-form-text>
                    非必要。多個標籤請用 <kbd>,</kbd> 或 <kbd>↵</kbd> 分隔
                  </b-form-text>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-form>
      <b-progress :value="status.modal.progress" v-if="status.modal.busy"></b-progress>
      <div slot="modal-footer" style="width: 100%">
        <b-row>
          <p class="text-info ml-3 mb-0">
            <fa-icon icon="info-circle"></fa-icon>
            影像上傳後，列表中的影像數量將依處理進度更新
          </p>
          <div class="d-lg-none" style="width: 100%"></div>
          <b-col align-self="end" style="text-align: right">
            <b-btn variant="secondary" @click="status.modal.show = false">取消</b-btn>
            <b-btn
              variant="primary"
              @click="onModalOk"
              :disabled="$v.modal.name.$invalid">
              {{ modalOkText }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, helpers } from 'vuelidate/lib/validators';
import customMixin from '../lib/mixin.js';
import posterWaiting from '../assets/poster-waiting.png';
import imageUtility from '../lib/image-utility.js';
import eventBus from '../lib/event-bus.js';
import { setInterval, clearInterval, setTimeout } from 'timers';
import '../../node_modules/@voerro/vue-tagsinput/dist/style.css';

export default {
  mixins: [validationMixin, customMixin],
  data () {
    return {
      id: this.decodeHash(location.hash),
      constant: {
        host: 'https://imageml2.webduino.io',
        maxImageLimit: 10,
        errorMessage: {
          noInputFile: '沒有選擇檔案，請選擇後重新上傳',
          noInputName: '請輸入資料集名稱',
          noPermission: '無法取得 Webcam 影像',
          noVideo: '從 Webcam 取得影像時發生未知錯誤'
        },
        strings: {
          emptyFilteredText: '找不到指定紀錄',
          emptyText: '沒有任何紀錄可顯示',
          webcam: {
            standby: '待命中',
            permission: '正在取得攝影機權限',
            reachLimit: '已達影像數量上限'
          },
          url: {
            standby: '待命中',
            reachLimit: '已達影像數量上限'
          }
        }
      },
      table: {
        items: [],
        fields: [
          { key: 'name', label: '名稱', sortable: true, sortDirection: 'desc', class: 'text-center' },
          { key: 'count', label: '影像數量', sortable: true, class: 'text-center' },
          { key: 'shareStatus', label: '分享狀態', class: 'text-center' },
          { key: 'actions', label: '操作' }
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        filter: null,
        onlyMe: true
      },
      modal: {
        mode: 0,
        name: '',
        zip: {
          file: null,
          tagFile: null
        },
        image: {
          files: [],
          tags: []
        },
        webcam: {
          formData: new FormData(),
          tags: []
        },
        url: {
          formData: new FormData(),
          tags: []
        }
      },
      status: {
        refreshIcon: false,
        modal: {
          show: false,
          busy: false,
          progress: 0,
          onEdit: false,
          webcam: {
            autoMode: false,
            rotate: 0,
            statusCode: 0,
            count: 0,
            interval: null
          },
          url: {
            link: '',
            hasError: false,
            autoMode: false,
            load: false,
            src: posterWaiting,
            rotate: 0,
            statusCode: 1,
            count: 0,
            interval: null
          }
        }, 
      }
    }
  },
  validations: {
    modal: {
      name: {
        required,
        specialChar: name => !/[\/\?\#]/.test(name)
      }
    }
  },
  methods: {
    toggleViewMode () {
      this.table.onlyMe = !this.table.onlyMe;
      eventBus.$emit('isPrivateDataset', this.table.onlyMe);
    },
    async loadTableData () {
      this.status.refreshIcon = true;
      const timer = new Promise((resolve, reject) => {
        setTimeout(resolve, 1500);
      });
      const getDataset = axios(`${this.constant.host}/mlapi/datasets?hashkey=${this.encodeHash()}`);
      const response = await Promise.all([timer, getDataset]);
      this.table.totalRows = response[1].data.length;
      this.$data.table.items = response[1].data;
      this.status.refreshIcon = false;
    },
    shareStatus (data) {
      const publicTemplate = { text: '公開分享', class: '', icon: 'users' };
      const privateTemplate = { text: '私人檔案', class: 'text-muted', icon: 'lock' };

      if (data.item.owner !== this.id) {
        publicTemplate.text = `由用戶 ${data.item.owner} 分享`;
      }
      return data.item.shared ? publicTemplate : privateTemplate;
    },
    shareLinkText (data) {
      return data.item.shared ? '取消分享' : '公開分享';
    },
    async shareDataset (data) {
      const hiddenInput = document.createElement('input').setAttribute('type', 'hidden');
      const confirm = await this.$swal({
        title: `正在${this.shareLinkText(data)}`,
        text: `${data.item.name} 目前為${this.shareStatus(data).text}，確定要${this.shareLinkText(data)}嗎？`,
        content: hiddenInput,
        buttons: {
          cancel: {
            text: '取消',
            visible: true,
            closeModal: true
          },
          confirm: { text: this.shareLinkText(data), closeModal: false }
        }
      });

      if (confirm) {
        const name = encodeURIComponent(data.item.name);
        const shareStatus = !data.item.shared;
  
        try {
          await axios.put(`${this.constant.host}/mlapi/dataset/${name}/shared/${shareStatus}?hashkey=${this.encodeHash()}`);
          await this.loadTableData();
          swal({
            icon: 'success',
            text: `太好了！已將 ${data.item.name} 設定為${this.shareLinkText(data)}`
          });
        } catch (ex) {
          console.error(ex);
          swal({
            icon: 'danger',
            text: `分享失敗，請再試一次`
          });
        }
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onOpen () {
      this.status.modal.show = true;
      this.status.modal.onEdit = false;
      this.status.modal.progress = 0;
      this.$refs.zipFileInput.reset();
      this.$refs.tagFileInput.reset();
      this.$refs.imageFileInput.reset();
      this.$data.modal = {
        mode: 0,
        name: '',
        zip: {
          file: null,
          tagFile: null
        },
        image: {
          files: [],
          tags: ''
        },
        webcam: {
          formData: new FormData(),
          tags: ''
        },
        url: {
          formData: new FormData(),
          link: ''
        }
      }
    },
    autoFocus () {
      this.$refs.autofocus.focus();
    },
    async onSubmit () {
      if (!this.formHasError) {
        const uploadPath = this.modal.mode === 0 ? 'uploadds' : 'uploadimgs';
        let formData = new FormData();
        let resetAfterUploading = false;

        switch (this.modal.mode) {
          case 0:
            // ZIP uploading
            formData.append('zipfile', this.modal.zip.file);
            if (this.modal.zip.tagFile) {
              formData.append('tagfile', this.modal.zip.tagFile);
            }
            break;
          case 1:
            // Bulk image uploading
            this.modal.image.files.forEach((image, index) => {
              formData.append('image', image);
            });
            if (this.modal.image.tags) {
              formData.append('tags', this.modal.image.tags);
            }
            break;
          case 2:
            // Upload image from webcam
            resetAfterUploading = true;
            formData = this.modal.webcam.formData;
            if (this.modal.webcam.tags) {
              formData.append('tags', this.modal.webcam.tags);
            }
            break;
          case 3:
            // Upload image from URL
            resetAfterUploading = true;
            formData = this.modal.url.formData;
            if (this.modal.url.tags) {
              formData.append('tags', this.modal.url.tags);
            }
            break;
        }
        try {
          this.status.modal.busy = true;
          const formReponse = await axios.post(
            `${this.constant.host}/mlapi/${uploadPath}/${encodeURI(this.modal.name)}?hashkey=${this.encodeHash()}`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
              onUploadProgress: progressEvent => {
                this.status.modal.progress =
                  Math.floor((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          );
          this.status.modal.busy = false;
          this.status.modal.show = false;
          if (formReponse.data.msg === 'OK') {
            if (resetAfterUploading) {
              this.status.modal.webcam.count = 0;
              this.modal.webcam.formData = new FormData();
              this.status.modal.url.count = 0;
              this.status.modal.url.statusCode = 1;
              this.modal.url.formData = new FormData();
            }
            setTimeout(async () => {
              /* Delay request since API doesn't reflect changes immediately */
              await this.loadTableData();
            }, 1000);
          }
        } catch (ex) {
          console.error(ex);
          swal({
            icon: 'error',
            text: '影像新增失敗，請稍後再試'
          });
        }
      }
    },
    onEdit (name) {
      this.onOpen();
      this.modal.name = name;
      this.status.modal.onEdit = true;
    },
    async onDelete (name) {
      const hiddenInput = document.createElement('input').setAttribute('type', 'hidden');
      const confirm = await this.$swal({
        text: `確定刪除 ${name}？`,
        dangerMode: true,
        content: hiddenInput,
        buttons: {
          cancel: {
            text: '取消',
            visible: true,
            closeModal: true
          },
          confirm: { text: '刪除', closeModal: false }
        }
      });

      if (confirm) {
        try {
          const response =
            await axios.delete(`${this.constant.host}/mlapi/datasets/${encodeURI(name)}?hashkey=${this.encodeHash()}`);
          await this.loadTableData();
          swal({
            icon: 'success',
            text: `已成功刪除 ${name}`
          });
        } catch (ex) {
          console.error(ex);
          swal({
            icon: 'error',
            text: `刪除 ${name} 時發生錯誤，請稍後再試`
          });
        }
      }
    },
    onModalOk (e) {
      e.preventDefault();
      this.onSubmit();
    },
    async modelTabSwitch (tabIndex) {
      switch (tabIndex) {
        case 0:
        case 1:
          this.status.modal.url.load = false;
          break;
        case 2:
          /* Stream tab */
          this.status.modal.url.load = false;
          await this.getStream();
          break;
        case 3:
          break;
      }
    },
    async loadImagefromURL () {
      this.status.modal.url.hasError = false;
      if (!this.status.modal.url.load) {
        this.status.modal.url.src = posterWaiting;
        return;
      }
      try {
        await new Promise(resolve => setTimeout(resolve, 300));
        let img = await imageUtility.load(this.status.modal.url.link);
        img = imageUtility.crop(img);
        if (this.status.modal.url.src === img) {
          const element = this.$refs['url-upload-preview'];
          element.dispatchEvent(new Event('load'));
        } else {
          this.status.modal.url.src = img;
        }
      } catch (ex) {
        this.status.modal.url.hasError = true;
      }
    },
    async loadURLPreview () {
      const element = this.$refs['url-upload-preview'];

      if (!this.status.modal.url.link) {
        return;
      }
      this.status.modal.url.load = true;
      element.onload = null;
      if (this.status.modal.url.load && this.status.modal.url.link) {
        element.onload = async () => { await this.loadImagefromURL() }
        await this.loadImagefromURL();
      } else {
        this.status.modal.url.src = posterWaiting;
      }
    },
    rotatePreview (type, degree) {
      const currentDegree = this.status.modal[type].rotate;
      let newDegree = 0;

      if (degree < 0) {
        if (currentDegree <= -270) {
          newDegree = 0;
        } else {
          newDegree = currentDegree + degree;
        }
      } else {
        if (currentDegree >= 270) {
          newDegree = 0;
        } else {
          newDegree = currentDegree + degree;
        }
      }
      this.status.modal[type].rotate = newDegree;
    },
    async getStream () {
      const video = this.$refs.video;

      try {
        this.status.modal.webcam.statusCode = 0;
        video.srcObject = await navigator.mediaDevices.getUserMedia({
          video: {
            width: 224,
            height: 224,
            facingMode: 'environment'
          }
        });
        video.play();
        this.status.modal.webcam.statusCode = 1;
      } catch (ex) {
        this.status.modal.webcam.statusCode = -1;
      }
    },
    async captureFromVideo (auto) {
      if (this.status.modal.webcam.interval && !auto) {
        return;
      }
      this.status.modal.webcam.statusCode = 2;
      if (this.status.modal.webcam.count >= 100) {
        this.status.modal.webcam.statusCode = 4;
        return;
      }
      const canvas = imageUtility.rotate(
        this.$refs.video,
        this.status.modal.webcam.rotate
      );
      await this.captureToFormData(canvas, this.modal.webcam.formData);
      this.status.modal.webcam.count++;
    },
    async onCapture (type) {
      if (this.status.modal[type].autoMode) {
        if (this.status.modal[type].interval) {
          clearInterval(this.status.modal[type].interval);
          this.status.modal[type].interval = null;
        } else {
          this.status.modal[type].interval = setInterval(async () => {
            if (type === 'webcam') {
              await this.captureFromVideo(true);
            }
            if (type === 'url') {
              await this.captureFromURL(true);
            }
          }, 500);
        }
      } else {
        await this.captureFrom(type);
      }
    },
    async captureFrom (type) {
      if (type === 'url') {
        return await this.captureFromURL();
      }
      if (type === 'webcam') {
        return await this.captureFromVideo();
      }
    },
    async captureFromURL (auto) {
      if (this.status.modal.url.interval && !auto) {
        return;
      }
      this.status.modal.url.statusCode = 2;
      if (this.status.modal.url.count >= 100) {
        this.status.modal.url.statusCode = 3;
        return;
      }
      const canvas = imageUtility.rotate(
        this.$refs['url-upload-preview'],
        this.status.modal.url.rotate
      );
      await this.captureToFormData(canvas, this.modal.url.formData);
      this.status.modal.url.count++;
    },
    unloadVideo () {
      const webcam = this.status.modal.webcam;

      webcam.statusCode = 1;
      webcam.autoMode = false;
      clearInterval(webcam.interval);
      webcam.interval = null;
    },
    clearFormData (type) {
      this.modal[type].formData = new FormData();
      this.status.modal[type].count = 0;
      this.status.modal[type].rotate = 0;
      this.status.modal[type].statusCode = 1;
    },
    captureToFormData (canvas, formData) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          formData.append('image', blob);
          resolve();
        });
      });
    },
    modalHidden () {
      this.stopUrlLoading();
      this.stopWebcam();
      this.clearFormData('webcam');
      this.clearFormData('url');
    },
    stopWebcam () {
      const video = this.$refs.video;
      this.unloadVideo();
      if (video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
        video.load();
      }
    },
    stopUrlLoading () {
      const url = this.status.modal.url;

      url.load = false;
      url.src = posterWaiting;
      url.link = '';
      url.autoMode = false;
      clearInterval(url.interval);
      url.interval = null;
    }
  },
  computed: {
    getCurrentHash () {
      return location.hash;
    },
    sortOptions () {
      return this.table.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } });
    },
    tableItem () {
      let items = [];

      if (this.table.onlyMe) {
        items = this.table.items.filter(item => item.owner === this.id);
      } else {
        items = this.table.items;
      }
      this.table.totalRows = items.length;
      return items;
    },
    imageOverLimit () {
      return this.modal.image.files.length > this.constant.maxImageLimit;
    },
    formInputMissing () {
      if (!this.modal.name) {
        return {
          result: true,
          message: this.constant.errorMessage.noInputName
        };
      }

      if (!this.modal.zip && this.modal.image.files.length === 0) {
        return {
          result: true,
          message: this.constant.errorMessage.noInputFile
        };
      }
      return { result: false, message: '' };
    },
    formHasError () {
      return this.imageOverLimit || this.formInputMissing.result;
    },
    modalTitle () {
      return this.status.modal.onEdit ? '加入照片' : '新增資料集';
    },
    modalOkText () {
      return this.status.modal.busy ? '上傳中...' : '上傳';
    },
    webcamStatusText () {
      let text = this.constant.strings.webcam.standby;

      switch (this.status.modal.webcam.statusCode) {
        case -1:
          text = this.constant.error.noPermission;
          break;
        case 0:
          text = this.constant.strings.webcam.permission;
          break;
        case 1:
          text = this.constant.strings.webcam.standby;
          break;
        case 2:
          text = `已擷取 ${this.status.modal.webcam.count} 張影像`;
          break;
        case 3:
          text = `已停止，共 ${this.status.modal.webcam.count} 張影像`;
          break;
        case 4:
          text = this.constant.strings.webcam.reachLimit;
          break;
      }
      return text;
    },
    captureButtonStatus () {
      const types = ['zip', 'image', 'webcam', 'url'];
      const currentType = types[this.modal.mode];

      if (typeof this.status.modal[currentType] === 'undefined') {
        return {
          icon: 'camera',
          variant: 'success',
          text: '擷取影像'
        }
      }

      if (this.status.modal[currentType].autoMode) {
        if (this.status.modal[currentType].interval) {
          return {
            icon: 'stop-circle',
            variant: 'danger',
            text: '停止擷取'
          }
        } else {
          return {
            icon: 'play-circle',
            variant: 'success',
            text: '開始擷取'
          }
        }
      } else {
        return {
          icon: 'camera',
          variant: 'success',
          text: '擷取影像'
        }
      }
    },
    urlUploadStatusText () {
      let text = this.constant.strings.url.standby;

      switch (this.status.modal.url.statusCode) {
        case 1:
          text = this.constant.strings.url.standby;
          break;
        case 2:
          text = `已擷取 ${this.status.modal.url.count} 張影像`;
          break;
        case 3:
          text = this.constant.strings.url.reachLimit;
          break
      }
      return text;
    }
  },
  async created() {
    await this.loadTableData();
    setInterval(async () => {
      await this.loadTableData();
    }, 10000);
  }
}
</script>

<style lang="scss">

.thin-title {
  font-weight: 200;
}

.custom-file-input ~ .custom-file-label::after {
  content: "瀏覽檔案";
}

.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;
  &:before {
    content: '';
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;
    padding: 0 .5em;
    line-height: 1.5em;
    color: #818078;
    background-color: #ffffff;
  }
}

.fa-spinner {
  color: #adb5bd
}

.nav.nav-tabs {
  outline: none;
}

.tags-input {
  height: auto;

  & input {
    width: 100%;
    min-width: 30px;
  }
  & .tags-input-badge {
    margin-top: 2px;
  }
}
</style>
